var Context = require('./context').Context;

var PatchContext = function PatchContext(left, delta) {
  this.left = left;
  this.delta = delta;
  this.pipe = 'patch';
};

PatchContext.prototype = new Context();

exports.PatchContext = PatchContext;



//////////////////
// WEBPACK FOOTER
// ./node_modules/jsondiffpatch/src/contexts/patch.js
// module id = 313
// module chunks = 55